export function validation_function(data) {
    let output = []
    for (let i = 0; i < data.length; i++) {
        const element = data[i];
        let setting = element.settings
        if (element.data === "validation") {
            let isrules = true
            let istimerules = true
            istimerules = Object.values({ time_from: setting.time_from, time_to: setting.time_to }).every(value => value !== "");
            for (let j = 0; j < setting.rules.length; j++) {
                isrules = Object.values(setting.rules[j]).every(value => value !== "");
            }
            if (isrules === false && istimerules === false) {
                output.push(element.id)
            }
        } else if (element.data === "audio") {
            if (setting.audio === "" || setting.audio === undefined) {
                output.push(element.id)
            }
        } else if (element.data === "conference") {
            if (setting.conf_num === "" || setting.conf_num === undefined) {
                output.push(element.id)
            }
        } else if (element.data === "dial") {
            if (setting.dialType === "Queue") {
                if (setting.queue === ""  ) {
                    output.push(element.id)
                }
            } else if (setting.dialType === "Number") {
                if (setting.DID === "Agent") {
                    if (setting.users.length === 0 || setting.users === "") {
                        output.push(element.id)
                    }

                } else if (setting.DID === "Others") {
                    if (setting.DIDNumber === "") {
                        output.push(element.id)
                    }

                } else {
                    output.push(element.id)
                }
            } else {
                output.push(element.id)
            }
        }
        else if (element.data==='sms'){
          
            if((setting.sms_txt===""||setting.sms_txt===undefined||setting.sms_txt===null)||(setting.sms_api===""||setting.sms_api===undefined||setting.sms_api===null)){
                output.push(element.id)
            }
            
        }
        else if (element.data === "menu") {
            let count = 0
            if (setting.choices.length !== setting.keys.length) {
                count += 1
            } else {
                for (let i = 0; i < setting.keys.length; i++) {
                    if (setting.keys[i] === "") {
                        count += 1
                    }
                    
                }
            }
            for (let i = 0; i < setting.choices.length; i++) {
                if (setting.choices[i] === "") {
                    count += 1
                }
                
               
            }
           let choices= check_duplicate_in_array(setting.choices)
            let keys=check_duplicate_in_array(setting.keys)
            if(choices.length>0||keys.length>0){
                count += 1
            }
            if(count>0){
                output.push(element.id)
            }

        }else if (element.data==="connection"){
            if((setting.conn_api===""||setting.conn_api===undefined||setting.conn_api===null)||(setting.conn_method===""||setting.conn_method===undefined||setting.conn_method===null)||(setting.conn_type===""||setting.conn_type===undefined||setting.conn_type===null)){
                output.push(element.id)
            }
        }

    }
    return output
}



const check_duplicate_in_array=(input_array)=>{ 
    const duplicates =input_array.filter((item, index) =>input_array.indexOf(item) !== index); 
    return Array.from(new Set(duplicates)); 
} 